<div id="act-statutes" class="inner-page">
  <div class="container-fluid px-lg-5">

    <h2 class="title">Act & Statutes</h2>
    <p class="inner-lead mt-3">
      The Act and Statutes govern the functioning of Shah Satnam Ji Girls' College, Sirsa as per the regulations of
      Chaudhary Devi Lal University (CDLU), Sirsa and the University Grants Commission (UGC). These documents outline
      the legal framework within which the institution operates.
    </p>

    <hr class="divider">

    <div class="pdf-block">
      <pdf-viewer src="/assets/pdf/hei/Act-and-Statutes.pdf" [render-text]="true" [original-size]="false"
        style="width:100%; height:680px; display:block;">
      </pdf-viewer>
    </div>

    <div class="mt-3">
      <a href="/assets/pdf/hei/Act-and-Statutes.pdf" target="_blank" class="pdf-download-btn">
        <i class="fa fa-download"></i> Download Act & Statutes
      </a>
    </div>

  </div>
</div>